'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var WashingMachine = function (_React$Component) {
    _inherits(WashingMachine, _React$Component);

    function WashingMachine() {
        _classCallCheck(this, WashingMachine);

        return _possibleConstructorReturn(this, (WashingMachine.__proto__ || Object.getPrototypeOf(WashingMachine)).apply(this, arguments));
    }

    _createClass(WashingMachine, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '26', height: '32', viewBox: '0 0 26 32' },
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M1.628 5.15v21.7c0 1.596 1.277 2.872 2.872 2.872h16.594c1.596 0 2.872-1.277 2.872-2.872V5.15c0-1.596-1.277-2.872-2.872-2.872H4.5c-1.596 0-2.872 1.277-2.872 2.872zm19.466 22.657H4.5c-.542 0-.957-.415-.957-.957V10.958h18.51V26.85c0 .542-.416.957-.958.957zM22.05 5.15v3.893H3.543V5.15c0-.542.415-.957.957-.957h16.593c.542 0 .957.415.957.957z' }),
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M12.797 12.17c-4.053 0-7.34 3.288-7.34 7.34s3.287 7.34 7.34 7.34 7.34-3.286 7.34-7.34-3.287-7.34-7.34-7.34zm0 12.765c-3 0-5.425-2.425-5.425-5.425s2.425-5.425 5.425-5.425 5.425 2.425 5.425 5.425-2.425 5.425-5.425 5.425z' }),
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M14.616 17.69c.99.99.99 2.618 0 3.607l1.34 1.34c1.755-1.755 1.755-4.563 0-6.32l-1.34 1.373zM15.35 8.18c.798 0 1.436-.637 1.436-1.435S16.148 5.31 15.35 5.31s-1.436.637-1.436 1.435.638 1.436 1.436 1.436zm0-1.913c.255 0 .48.223.48.48s-.224.478-.48.478-.48-.223-.48-.48.224-.478.48-.478zM18.54 8.18c.8 0 1.437-.637 1.437-1.435S19.34 5.31 18.54 5.31s-1.435.637-1.435 1.435.638 1.436 1.436 1.436zm0-1.913c.256 0 .48.223.48.48s-.223.478-.48.478-.478-.223-.478-.48.223-.478.48-.478z' })
            );
        }
    }]);

    return WashingMachine;
}(_react2.default.Component);

WashingMachine.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = WashingMachine;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/washing-machine.js
// module id = 1133
// module chunks = 0